import React from 'react'
import styled from 'styled-components';
import {InnerLayout} from '../styles/Layouts';
import Title from '../Components/Title';


function DaboutSetion() {
    return (
        <DaboutStyled>
            <Title title={'about'}  />
            <InnerLayout>
                <div className="Dabout">
                Hi! I am James Au. I am a Psychology student at UC Davis. 
                I took a Computer Science class in last quarter and has been hooked since.
                 Right now, I am most interested in learning web development:CSS flexbox, CSS grid and React.js.
                  I spend most of my free time researching the latest web design trend and techniques, as well as coding.
                    
                </div>
            </InnerLayout>
        </DaboutStyled>
    )
}

const DaboutStyled = styled.section`
    .Dabout{
        display: flex;
        width: 100%;
        @media screen and (max-width:650px){
            grid-template-columns: repeat(1, 1fr);
        }
    }
`;

export default DaboutSetion;
